import React from 'react'
import { Shimmer, SkeletonElement } from '..';

const SkeletonSugestedCom: React.FC = () => {
  return (
    <div className='gap-3 items-center overflow-hidden relative'>
      <div className="flex items-center justify-between pr-2">
        <SkeletonElement type="menu" />
        <div className="grid w-9/12">
          <SkeletonElement type="title" />
          <SkeletonElement type="title" />
        </div>
        <SkeletonElement type="icon" />
      </div>
      <Shimmer/>
    </div>
  )
}

export default SkeletonSugestedCom;